<template>
  <div v-if="duplicateGroups.length > 0">
    <div class="duplicate-group-card-list">
      <duplicate-group-card
        v-for="{ mainCopy, duplicates } in duplicateGroups"
        :key="mainCopy.id"
        :main-copy="mainCopy"
        :duplicates="duplicates"
        @mark-as-duplicate="
          $emit('mark-as-duplicate', { mainCopy, reference: $event })
        "
        @mark-as-not-duplicate="
          $emit('mark-as-not-duplicate', {
            mainCopy,
            reference: $event,
          })
        "
      />
    </div>
  </div>
  <page-content-placeholder
    v-else
    icon="file_copy"
    :prompt-text="emptyStateTitle"
  >
    <template #message>
      <div class="text-center message">
        {{ emptyStateMessage }}
      </div>
    </template>
    <template #action>
      <action-button
        v-if="!hideBackButton"
        color="primary"
        @click="$emit('go-back')"
      >
        <v-icon left>arrow_back</v-icon>
        <span>Go back to the review</span>
      </action-button>
    </template>
  </page-content-placeholder>
</template>

<script>
import PageContentPlaceholder from '@/components/Common/PageContentPlaceholder';
import ActionButton from '@/components/Common/ActionButton';
import DuplicateGroupCard from './DuplicateGroupCard';
import { ReferenceDuplicateGroupDto } from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'DuplicateGroupCardList',
  components: {
    PageContentPlaceholder,
    ActionButton,
    DuplicateGroupCard,
  },
  props: {
    duplicateGroups: {
      type: Array,
      default: () => [],
      validator: (duplicateGroups) =>
        typeHelpers.isArrayOfType(
          duplicateGroups,
          ReferenceDuplicateGroupDto
        ),
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    emptyStateTitle: {
      type: String,
      required: true,
    },
    emptyStateMessage: {
      type: String,
      required: true,
    },
    hideBackButton: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['mark-as-duplicate', 'mark-as-not-duplicate', 'go-back'],
};
</script>

<style lang="scss" scoped>
.duplicate-group-card-list {
  display: grid;
  gap: 32px;
  height: 100%;
}
</style>
